import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

import { COMPARE_ONBOARDING_COOKIE_NAME, TRUTHY_COOKIE_CONTENT } from '../constants/compare';

export function getCompareOnboardingCookie(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return parseCookies(window.document.cookie)[COMPARE_ONBOARDING_COOKIE_NAME] === TRUTHY_COOKIE_CONTENT;
}

export function setCompareOnboardingCookie(): void {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };

  setCookie(COMPARE_ONBOARDING_COOKIE_NAME, TRUTHY_COOKIE_CONTENT, cookieConfig);
}
